import ScenarioOverview from "./ScenarioOverview";

export default function Transactional() {
  return <ScenarioOverview />;
}
